import * as types from './types';

const setSummaryWidgets = ({ widgets, type }) => ({
  type: types.SET_SUMMARY_WIDGETS,
  data: { widgets, type },
});

export { setSummaryWidgets };
